/**
 * 
 * @param {Array} variants
 * @param {Object} (element) - form field that holds the variant
 * @returns {Object} current variant
 */

const getCurrentVariant = variants => variantIdFormField => () => {
  const id = parseInt(variantIdFormField.value)
  return variants.find(variant => parseInt(variant.id) === id)
}

export default getCurrentVariant;